import { useMemo } from "react";
import { useStore } from "./useStore";
import { SelectOption } from "../components/common/PL/Select/Select";

/** Tipos de vehículo (carrocería) administrados por el admin de edificios. Vienen dentro de
 * `globalOptions`, así que no hace falta un fetch propio: ya están en el authStore. */
const useVehicleTypes = () => {
  const { authStore } = useStore();

  const vehicleTypes: SelectOption[] = useMemo(
    () =>
      (authStore.vehicleTypes ?? [])
        .map((type: any) => ({
          value: type.id,
          label: type.name,
        }))
        ?.sort((a: SelectOption, b: SelectOption) => b.label.localeCompare(a.label)),
    [authStore.vehicleTypes]
  );

  return { vehicleTypes };
};

export default useVehicleTypes;
